import { render, staticRenderFns } from "./IdentificationLogStaff.vue?vue&type=template&id=08ae322d&scoped=true&"
import script from "./IdentificationLogStaff.vue?vue&type=script&lang=js&"
export * from "./IdentificationLogStaff.vue?vue&type=script&lang=js&"
import style0 from "./IdentificationLogStaff.vue?vue&type=style&index=0&id=08ae322d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ae322d",
  null
  
)

export default component.exports